import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { LoggedInRoute, ProtectedRoutes } from "./utils/ProtectedRoutes";
import {
  DASHBOARD,
  GENERAL,
  HOME,
  ABOUT,
  BLOG,
  LOGIN,
  SETTINGS,
  SIGN_UP,
  SUCCESS,
  SEARCH,
  ONBOARDING,
  LISTINGS,
  INSPECTION,
  VERIFY_OTP,
  PAYMENTS,
  ADMIN_BOOKING,
  CATALOG,
  ADMIN_USER_MGT,
  ADMIN_PROP_MGT,
  ADMIN_PAYMENTS,
} from "./utils/routes";

const Login = lazy(() => import("./Pages/Auth/Login"));
const Otp = lazy(() => import("./Pages/Auth/Otp"));
const SignUp = lazy(() => import("./Pages/Auth/SignUp"));
const SignUpStart = lazy(() => import("./Pages/Auth/SignUpStartPage"));
const SignUpSuccess = lazy(() => import("./Pages/Auth/SignUpSuccess"));
const Dashboard = lazy(() => import("./Pages/Dashboard"));
const DashboardHome = lazy(() => import("./Pages/Dashboard/Dashboard"));
const ListingHome = lazy(() => import("./Pages/Dashboard/AppPages/Listings"));
const ListingTable = lazy(() =>
  import("./Pages/Dashboard/AppPages/Listings/ListingTable.js")
);
const ListingAction = lazy(() =>
  import("./Pages/Dashboard/AppPages/Listings/ListingAction")
);
const PropertyMgt = lazy(() =>
  import("./Pages/Dashboard/AppPages/PropertyMgt")
);
const PropertyMgtTable = lazy(() =>
  import("./Pages/Dashboard/AppPages/PropertyMgt/ListingTable")
);
const InspectionHome = lazy(() =>
  import("./Pages/Dashboard/AppPages/Inspection")
);
const PaymentHome = lazy(() => import("./Pages/Dashboard/AppPages/Payment"));
const PaymentDetails = lazy(() =>
  import("./Pages/Dashboard/AppPages/Payment/PaymentTableDetails")
);
const RemittanceDetails = lazy(() =>
  import("./Pages/Dashboard/AppPages/Payment/RemittanceTableDetails")
);
const PaymentAdd = lazy(() =>
  import("./Pages/Dashboard/AppPages/Payment/PaymentAdd")
);
const PaymentMgt = lazy(() => import("./Pages/Dashboard/AppPages/PaymentMgt"));
const PaymentMgtTable = lazy(() =>
  import("./Pages/Dashboard/AppPages/PaymentMgt/PaymentTable")
);

const PropertyDetails = lazy(() =>
  import("./Pages/Dashboard/AppPages/PropertyMgt/PropertyDetails")
);
// const PaymentMgtDetails = lazy(() =>
//   import("./Pages/Dashboard/AppPages/PaymentMgt/PaymentTableDetails")
// );

const Setting = lazy(() => import("./Pages/Dashboard/Settings"));
const System = lazy(() => import("./Pages/Dashboard/System"));
const General = lazy(() => import("./Pages/Dashboard/GeneralSetting"));
const HomePage = lazy(() => import("./Pages/HomePage/HomePage"));
const AboutPage = lazy(() => import("./Pages/AboutPage/AboutPage"));
const BlogPage = lazy(() => import("./Pages/BlogPage/BlogPage"));
const Blog = lazy(() => import("./Pages/BlogPage/Blog"));
const SearchResult = lazy(() => import("./Pages/SearchResult/SearchResults"));
const ViewFeaturedListing = lazy(() =>
  import("./components/SearchResult/ViewFeaturedListings.js")
);
const SearchResultDetails = lazy(() =>
  import("./Pages/SearchResult/SearchResultDetails")
);
const Checkout = lazy(() => import("./components/checkout/Checkout"));
const DashboardRental = lazy(() =>
  import("./Pages/DashBoardRental/DashboardRental")
);
const SavedProperty = lazy(() =>
  import("./Pages/DashBoardRental/SavedProperties")
);

const Catalog = lazy(() => import("./Pages/Dashboard/AppPages/Catalog"));

//Adming Routes

const Users = lazy(() => import("./Pages/Dashboard/AppPages/AdminPages/Users"));

const Booking = lazy(() =>
  import("./Pages/Dashboard/AppPages/AdminPages/Booking")
);

function Main() {
  return (
    <Suspense fallback={"Loading..."}>
      <Router>
        <Routes>
          <Route path={HOME} element={<HomePage />} />
          <Route path={ABOUT} element={<AboutPage />} />
          <Route path={BLOG} element={<BlogPage />} />
          <Route path={BLOG + "/:id"} element={<Blog />} />
          <Route path={SEARCH} element={<SearchResult />} />
          <Route path='/featured-listings' element={<ViewFeaturedListing />} />
          <Route path={SEARCH + "/:id"} element={<SearchResultDetails />} />
          <Route path={"checkout" + "/:id"} element={<Checkout />} />
          <Route path={"manage-property"} element={<DashboardRental />} />
          <Route path={"saved-properties"} element={<SavedProperty />} />

          {/* <Route element={<Successful />}>
            <Route path={SUCCESS} element={<Success />} />
          </Route> */}

          <Route element={<LoggedInRoute />}>
            <Route path={LOGIN} element={<Login />} />
            <Route path={VERIFY_OTP} element={<Otp />} />
            <Route path={SIGN_UP} element={<SignUpStart />} />
            <Route path={ONBOARDING} element={<SignUp />} />
            <Route path={SUCCESS} element={<SignUpSuccess />} />
          </Route>
          <Route element={<ProtectedRoutes />}>
            {/* 
              <Route index element={<DashboardHome />} />
              <Route path={SETTINGS} element={<Setting />}>
                </Route> */}
            <Route path={DASHBOARD} element={<Dashboard />}>
              <Route index element={<DashboardHome />} />
              <Route path={SETTINGS} element={<Setting />}>
                <Route index element={<System />} />
                <Route path={GENERAL} element={<General />} />
              </Route>
              <Route path={INSPECTION} element={<InspectionHome />} />
              <Route path={PAYMENTS} element={<PaymentHome />}>
                <Route index element={<PaymentDetails />} />
                <Route path={"add"} element={<PaymentAdd />} />
                <Route path={"remittance"} element={<RemittanceDetails />} />
              </Route>
              <Route path={ADMIN_PAYMENTS} element={<PaymentMgt />}>
                <Route index element={<PaymentMgtTable />} />
                {/* <Route path={"add"} element={<PaymentAdd />} />
                <Route path={"remittance"} element={<RemittanceDetails />} /> */}
              </Route>
              <Route path={LISTINGS} element={<ListingHome />}>
                <Route index element={<ListingTable />} />
                <Route
                  path={":operation/:actions/:type/:stage"}
                  element={<ListingAction />}
                />
                <Route
                  path={":operation/:actions/:type/:stage/:id"}
                  element={<ListingAction />}
                />
                <Route path={GENERAL} element={<General />} />
              </Route>
              <Route path={ADMIN_PROP_MGT} element={<PropertyMgt />}>
                <Route index element={<PropertyMgtTable />} />
                <Route path={"property/:id"} element={<PropertyDetails />} />
              </Route>
              <Route
                path={"*"}
                element={
                  <>
                    <h2>In development</h2>
                  </>
                }
              />

              <Route path={CATALOG} element={<Catalog />} />

              <Route path={ADMIN_BOOKING} element={<Booking />} />
              <Route path={ADMIN_USER_MGT} element={<Users />} />
            </Route>
          </Route>
          <Route
            path={"*"}
            element={
              <>
                <h2>Page not Found</h2>
              </>
            }
          />
        </Routes>
      </Router>
    </Suspense>
  );
}

export default Main;
